import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { trackServiceInterest } from '../../utils/analytics';

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  linkHref?: string;
  linkText?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  icon,
  title,
  description,
  linkHref = '/pricing',
  linkText = 'View Pricing',
}) => {
  // Check if the link is internal or external, and whether it includes a hash fragment
  const isInternalLink = linkHref.startsWith('/');
  const hasHashFragment = linkHref.includes('#');

  const handleServiceClick = () => {
    trackServiceInterest(title, 'click');
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:translate-y-[-5px] border-t-4 border-transparent hover:border-[#f59d40] group flex flex-col h-full">
      <div className="mb-4 bg-[#bb141a] bg-opacity-20 w-14 h-14 rounded-lg flex items-center justify-center group-hover:bg-[#bb141a] group-hover:text-white transition-all duration-300 relative overflow-hidden">
        {/* Light source effect */}
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-white to-transparent opacity-30 group-hover:opacity-40 transition-opacity"></div>
        <div className="absolute -inset-1 bg-[#bb141a] opacity-0 group-hover:opacity-20 blur-md group-hover:blur-xl transition-all duration-300"></div>
        <div className="transition-colors relative z-10">
          {icon}
        </div>
      </div>
      <h3 className="text-xl font-bold mb-2 text-[#2a2b2a]">{title}</h3>
      <p className="text-[#2a2b2a] opacity-80">{description}</p>
      <div className="mt-auto pt-4">
        {isInternalLink ? (
          hasHashFragment ? (
            <HashLink
              smooth
              to={linkHref}
              onClick={handleServiceClick}
              className="inline-flex items-center justify-center w-full text-[#bb141a] font-medium hover:text-[#ea5830] transition-colors"
            >
              {linkText}
              <ArrowRight className="ml-2 h-4 w-4" />
            </HashLink>
          ) : (
            <Link 
              to={linkHref}
              onClick={handleServiceClick}
              className="inline-flex items-center justify-center w-full text-[#bb141a] font-medium hover:text-[#ea5830] transition-colors"
            >
              {linkText}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          )
        ) : (
          <a 
            href={linkHref}
            onClick={handleServiceClick}
            className="inline-flex items-center justify-center w-full text-[#bb141a] font-medium hover:text-[#ea5830] transition-colors"
            target="_blank"
            rel="noopener noreferrer"
          >
            {linkText}
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        )}
      </div>
    </div>
  );
};

export default ServiceCard; 